export enum AlertMessages {
  SUCCESS = "Operação realizada com sucesso",
  ERROR = "Oops! Algo não saiu como esperado. Tente novamente!",
}